const apiKey = "c4c5f0be3de7790953f90adb667c8254";
export default apiKey;